import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  text-align: left;
  padding: 35px;
  max-height: 700px;

  .test-results {
    margin-bottom: 20px;
  }

  .test-results-header {
    margin-top: 20px;
  }

  .test-results-card {
    background: white;
    padding: 10px;
    border-radius: 10px;
    margin-top: 20px;
  }

  .endpoint-select {
    margin-bottom: 10px;
  }
`;
